import { useTranslation } from 'react-i18next'

import { StepImpactsModal } from 'src/components/associations-modal/step-impacts-modal.component'

import { AssociationsType, ETranslationNs, IImpactByIdRawRespDto } from 'src/types'
import { ScanImpactAssociation } from '../impact-association'

interface IProps {
  step_id: string
  selectedItems: string[]
  selectedImpactsIcons: IImpactByIdRawRespDto[]
  handleSelectedImpact: (id: string) => void
  error?: string
  disableSelection?: boolean
}

const ImpactsAssociationInput = (props: IProps) => {
  const [t] = useTranslation(ETranslationNs.Form)

  return (
    <ScanImpactAssociation
      error={props.error}
      modalContentNode={
        !props.disableSelection ? (
          <StepImpactsModal
            type={AssociationsType.IMPACTS}
            stepId={props.step_id}
            selectedItems={props.selectedItems}
            handleSelectItem={props.handleSelectedImpact}
          />
        ) : undefined
      }
      description={t('impact-association-title.v')}
      handleSelectItem={props.handleSelectedImpact}
      connections={props.selectedImpactsIcons}
      disable={props.disableSelection}
    />
  )
}

export { ImpactsAssociationInput }
